// EN
export const derivedRatesSection = {
  title: "Abgeleitete Raten",
  description:
    "Erstellen Sie Raten auf Basis Ihrer Haupttarife, um sich mit verschiedenen OTAs zu verbinden und dabei einen zentralen Grundpreis zu behalten.",
  newRate: "Neue abgeleitete Rate",
  loading: "Raten werden geladen...",

  otaBadge: "OTA",
  otaLockedTitle: "OTA-Rate: wird unter „OTA verbinden“ verwaltet",
  salePaused: "Verkauf pausiert",

  columns: {
    name: "Name",
    adjustment: "Anpassung",
    finalPrice: "Endpreis",
  },

  actions: {
    resumeTitle: "Verkauf auf Channex fortsetzen",
    pauseTitle: "Verkauf auf Channex pausieren (stop_sell)",
    edit: "Bearbeiten",
    delete: "Löschen",
    protectedTitle: "Geschützt: unter „OTA verbinden“ ändern oder entfernen",
  },

  empty: {
    title: "Keine abgeleiteten Raten",
    text: "Erstellen Sie abgeleitete Raten auf Basis Ihrer Haupttarife, um sich mit OTAs zu verbinden",
    create: "Erste abgeleitete Rate erstellen",
  },

  modal: {
    editTitle: "Abgeleitete Rate bearbeiten",
    createTitle: "Neue abgeleitete Rate",
    baseRatePlan: "Basistarif",
    selectBasePlaceholder: "Basistarif auswählen",
    selectBaseHint:
      "Wählen Sie den Tarif, aus dem diese abgeleitete Rate berechnet wird",
    nameLabel: "Name der abgeleiteten Rate",
    namePlaceholder: "Z. B. Booking.com-Rate, Airbnb-Rate",
    nameHint: "Dieser Name hilft Ihnen, die Rate beim Verbinden mit OTAs wiederzuerkennen",
    adjustmentType: "Art der Anpassung",
    percentage: "Prozentsatz",
    fixedAmount: "Fester Betrag",
    adjustmentValue: "Wert der Anpassung",
    adjustmentValueHint: "(negative Werte für Rabatte verwenden)",
    cancel: "Abbrechen",
    saving: "Wird gespeichert...",
    update: "Aktualisieren",
    create: "Rate erstellen",
  },

  preview: {
    title: "Vorschau",
    basePrice: "Grundpreis",
    increment: "Aufschlag",
    discount: "Rabatt",
    finalPrice: "Endpreis",
  },

  delete: {
    title: "Abgeleitete Rate löschen",
    warnStrong: "Diese Aktion kann nicht rückgängig gemacht werden.",
    warnText:
      "Stellen Sie vor dem Löschen sicher, dass die Rate {name} mit keiner OTA verknüpft ist.",
    confirmLabel: "Geben Sie zur Bestätigung den genauen Namen ein:",
    confirmPlaceholder: "Name der Rate exakt eingeben",
    confirmHint:
      "Fügen Sie den Namen genau wie oben angezeigt ein oder tippen Sie ihn ab, um die Schaltfläche zum Löschen freizuschalten.",
    cancel: "Abbrechen",
    processing: "Wird gelöscht...",
    confirm: "Endgültig löschen",
  },

  pause: {
    resumeTitle: "Verkauf fortsetzen",
    pauseTitle: "Verkauf pausieren",
    resumeText:
      "{code} wird für die nächsten 500 Tage an Channex gesendet. Der Kanal erhält wieder Verfügbarkeit und kann Buchungen annehmen.",
    pauseText:
      "{code} wird für die nächsten 500 Tage an Channex gesendet. Der mit dieser Rate verknüpfte Kanal kann währenddessen keine neuen Buchungen annehmen.",
    note: "Der Hauptkalender und andere Kanäle sind nicht betroffen. Zum Fortsetzen klicken Sie auf die Schaltfläche ▶ der Rate.",
    cancel: "Abbrechen",
    resuming: "Wird fortgesetzt...",
    pausing: "Wird pausiert...",
    confirmResume: "Ja, Verkauf fortsetzen",
    confirmPause: "Ja, Verkauf pausieren",
  },

  toast: {
    loadError: "Fehler beim Laden der Daten",
    fillRequired: "Bitte füllen Sie alle Pflichtfelder aus",
    updated: "Rate erfolgreich aktualisiert",
    created: "Rate erfolgreich erstellt",
    saveFailed: "Die Rate konnte nicht gespeichert werden",
    saveError: "Fehler beim Speichern der abgeleiteten Rate",
    deleted: "Abgeleitete Rate gelöscht",
    deleteFailed: "Die Rate konnte nicht gelöscht werden",
    deleteLinkedOta: "Löschen nicht möglich: Die Rate ist mit einer OTA verknüpft.",
    nameMismatch: "Der eingegebene Name stimmt nicht überein.",
    deleteError: "Fehler beim Löschen der abgeleiteten Rate",
    salesPaused: "Verkauf pausiert",
    salesResumed: "Verkauf fortgesetzt",
    toggleFailed: "Der Status konnte nicht geändert werden",
    toggleError: "Fehler beim Ändern des Ratenstatus",
    // Guardada en local, pero Channex no aceptó el cambio (channex_synced:false).
    channexNotSynced: "Die Rate wurde gespeichert, aber der Channel Manager hat die Änderung nicht übernommen: Die Kanäle haben noch den vorherigen Stand. Prüfe die Angaben und versuche es erneut.",
  },

  // Estancia mínima propia de una derivada (own_min_stay). Campo y chip
  // compartidos: OwnMinStayField.vue / OwnMinStayChip.vue.
  ownMinStay: {
    label: "Eigener Mindestaufenthalt (Nächte)",
    hint: "Leer = wie bei der Hauptrate",
    mixedPlaceholder: "Verschieden",
    mixedHint: "Jedes Zimmer hat ein anderes Minimum. Wenn du einen Wert eingibst, gilt er für alle; bleibt das Feld leer, behält jedes sein eigenes.",
    // Sugerencia por el nombre («Tarifa semanal» → 7): una pregunta de un clic.
    suggestQuestion: "Mindestens {n} Nacht? | Mindestens {n} Nächte?",
    suggestUse: "Übernehmen",
    clear: "Entfernen",
    channelNote: "{channel} erhält für diese Rate einen Mindestaufenthalt von {n} Nacht. | {channel} erhält für diese Rate einen Mindestaufenthalt von {n} Nächten.",
    genericNote: "Die verbundenen Kanäle (Booking usw.) erhalten für diese Rate einen Mindestaufenthalt von {n} Nacht. | Die verbundenen Kanäle (Booking usw.) erhalten für diese Rate einen Mindestaufenthalt von {n} Nächten.",
    chip: "Min. {n} Nacht | Min. {n} Nächte",
    chipMixed: "Min. je Zimmer verschieden",
    chipTitle: "Eigener Mindestaufenthalt dieser Rate: wird an die verbundenen Kanäle gesendet",
    // Grupo con mínimos distintos: quitárselo a todas es un gesto aparte.
    clearAll: "Minimum bei allen entfernen",
    clearedAllHint: "Beim Speichern verlieren alle ihr eigenes Minimum und nutzen das der Hauptrate.",
    undo: "Rückgängig",
  },
};
